import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  AppTableComponent,
  ModalWindowComponent,
  SearchModel,
  SearchResultModel,
  SupplierOfferListModel,
  SupplierOfferService,
  Auth,
  MessagesComponent,
  SupplierRoundListModel, SupplierRoundListService
} from 'src/common';
import { TranslationManager } from 'src/common/translation';
import { ActivatedRoute, Router } from '@angular/router';
import { LocaleService } from 'src/common/services/locale';


@Component({
  selector: 'app-supplier-offer-list-ssy1200list',
  templateUrl: './supplier-offer-list-ssy1200list.component.html'
})
export class SupplierOfferListSsy1200listComponent implements AfterViewInit, OnInit {

  requestRoundSupplierId: number;
  displaySendModal = false;
  displayReturnInProgress = false;
  sendID: number;
  requestRoundStatusUniqueIdentifier: string;
  requestRoundId: number;
  procurementModelUniqueIdentifier: string;
  checkDate: boolean;

  localeService = LocaleService;

  constructor(private router: Router, private supplierOfferListViewService: SupplierOfferService, private route: ActivatedRoute,
    private supplierRoundListViewService: SupplierRoundListService) {
  }


  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("modalWindow") modalWindow: ModalWindowComponent;
  translationManager = TranslationManager;
  items: SupplierOfferListModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;
  customHeaderText = '';

  ngOnInit(): void {
    this.requestRoundSupplierId = +this.route.snapshot.params['id'];
  }


  ngAfterViewInit(): void {
    let search1 = new SearchModel();
    search1.filters.push({ 'entity': "RequestRoundSupplierId", 'value': this.requestRoundSupplierId + '', 'action': "equals" });
    this.supplierRoundListViewService.search(search1).then((result: SearchResultModel<SupplierRoundListModel>) => {
      let items1 = result.items;
      this.setCheckDate(items1[0]);
      this.requestRoundStatusUniqueIdentifier = items1[0].requestRoundStatusUniqueIdentifier;
      this.requestRoundId = items1[0].requestRoundId;
      this.procurementModelUniqueIdentifier = items1[0].procurementModelUniqueIdentifier;
      this.appTable.onSearch = this.doSearch.bind(this);
      this.appTable.search();
    })
  }

  doSearch(search: SearchModel) {
    if (!search) {
      search = new SearchModel();
    }

    search.filtersDefault = [];
    let f1 = search.filtersDefault.filter(a1 => a1.entity == 'RequestRoundSupplierId');
    if (!f1 || f1.length == 0) {
      search.filtersDefault.push({ 'entity': "RequestRoundId", 'value': this.requestRoundId + '', 'action': "equals" });
    }
    this.supplierOfferListViewService.search(search).then((result: SearchResultModel<any>) => {
      this.items = result.items;
      this.appTable.setTotalCount(result.totalCount);
    })
  }

  create() {
    this.routerNavigateToCreate();
  }

  openDetails(id: number) {
    this.router.navigate(['/supplierOfferLists/details/' + id]);
  }

  delete() {
    this.showDeleteModal = false;
    this.supplierOfferListViewService.delete(this.idForDelete).then(() => {
      this.appTable.search();
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
    });
  }


  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  routerNavigateToCreate() {
    this.supplierOfferListViewService.init(this.requestRoundSupplierId).then(res => {
      this.appTable.search();
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Понуда је успешно иницијализована')]);
      setTimeout(()=>{
         this.showEditForm();
      }, 1000/2);
    });
  }

  showEditForm(){

    if(this.items[0]){
      if(this.items[0].supplierOfferId){
        const lsupplierOfferId =  this.items[0].supplierOfferId;
        this.router.navigate(['/supplier-offers/edit/' + this.requestRoundSupplierId + '/' + lsupplierOfferId ]);
      }
    }
  }

  showSendModalFor(id: number) {
    this.displaySendModal = true;
    this.sendID = id;
  }

  showModalReturnInProgress(id: number) {
    this.displayReturnInProgress = true;
    this.sendID = id;
  }

  send() {
    let status: string;

    status = 'Submitted';

    this.supplierOfferListViewService.changeStatus({ 'id': this.sendID, 'status': status }).then(() => {
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('SupplierOfferList_SendSuccessMsg')]);
      this.displaySendModal = false;
      this.appTable.onSearch = this.doSearch.bind(this);
      this.appTable.search();
    }).catch((reason: any) => {
      this.displaySendModal = false;

      if (reason !== null) {
        if (reason.status === 400) {
          if (reason.error !== null) {
            const mescustom = reason.error.messages;
            MessagesComponent.instance.showError([mescustom]);
          }
        } else {
          MessagesComponent.instance.showError(reason.error.messages);
        }
      }
    });
  }


  sendReturnInProgress() {
    let status: string;

    status = 'InProgress';

    this.supplierOfferListViewService.changeStatus({ 'id': this.sendID, 'status': status }).then(() => {
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Одустанак од слања понуде')]);
      this.displayReturnInProgress = false;
      this.appTable.onSearch = this.doSearch.bind(this);
      this.appTable.search();
    }).catch((reason: any) => {
      this.displayReturnInProgress = false;

      if (reason !== null) {
        if (reason.status === 400) {
          if (reason.error !== null) {
            const mescustom = reason.error.messages;
            MessagesComponent.instance.showError([mescustom]);
          }
        } else {
          MessagesComponent.instance.showError(reason.error.messages);
        }
      }
    });
  }

  checkStatusUniqueIdentifier(identifier: string): boolean {
     if ((identifier == 'InProgress' || identifier == 'Entered') &&
        this.requestRoundStatusUniqueIdentifier == 'Initiated' && this.checkDate) {
        return true;
    } else {
      return false;
    }
  }

  setCheckDate(res: any): void {
    let currentDate = new Date().getTime();
    let requestDeadline = new Date(res.requestDeadline).getTime();
    this.checkDate = currentDate > requestDeadline ? false : true;
  }

  checkCompletionDate(completionDeadline: string): boolean {
    let currentDate = new Date().getTime();
    let completionTimestamp = new Date(completionDeadline).getTime();

    if (completionTimestamp < currentDate) {
      return false;
    } else {
      return true;
    }
  }

  navigateToBack() {
    this.router.navigate(['/supplier-rounds']);
  }
}
